import type { IconProps } from './types';
import './icons.css';

export default function Down({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 10}
      height={height || 7}
      viewBox="0 0 10 7"
      className={`icon icon-down ${className || ''}`}
      fill="none"
    >
      <path stroke="currentColor" d="M1 1L5 5L9 1" />
    </svg>
  );
}
